import { FC } from 'react';

import OperationDetailsTableHeader from './OperationDetailsTableHeader';

import OperationDetailsTableBody from './OperationDetailsTableBody';
import OperationDetailsTableFooter from './OperationDetailsTableFooter';

const OperationDetailsTable: FC = () => (
  <div className="card card-bordered">
    <table className="nk-tb-list nk-tb-ulist table table-striped">
      <OperationDetailsTableHeader />

      <OperationDetailsTableBody />

      <OperationDetailsTableFooter />
    </table>
  </div>
);

export default OperationDetailsTable;
